import { gql } from '@apollo/client'

const CREATE_LAB_RESULT_FROM_UPLOAD = gql`
  mutation createLabResultFromUpload($fileId: ID!) {
    createLabResultFromUpload(fileId: $fileId) {
      id
      createdAt
      source
    }
  }
`

export default CREATE_LAB_RESULT_FROM_UPLOAD
